///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, kioskProductionListActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getKioskProductionList = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const bodyMsg = payload.filters

	const apiCall = R.GET_KIOSK_PRODUCTION_LIST(payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(kioskProductionListActionCreators.getKioskProductionListSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskProductionListActionCreators.getKioskProductionListFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getInfosSimCard = function* ({ payload }) {
	const user = yield select(selectIdsUser)

	const apiCall = R.GET_KIOSK_PRODUCTION_INFOS_SIMCARD(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(kioskProductionListActionCreators.getInfosSimCardSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskProductionListActionCreators.getInfosSimCardFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getInfosBattery = function* ({ payload }) {
	const user = yield select(selectIdsUser)

	const apiCall = R.GET_KIOSK_PRODUCTION_INFOS_BATTERY(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(kioskProductionListActionCreators.getInfosBatterySuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskProductionListActionCreators.getInfosBatteryFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getInfosWS = function* ({ payload }) {
	const user = yield select(selectIdsUser)

	const apiCall = R.GET_KIOSK_PRODUCTION_INFOS_WS(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(kioskProductionListActionCreators.getInfosWSSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskProductionListActionCreators.getInfosWSFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_KIOSK_PRODUCTION_LIST, getKioskProductionList)
	yield takeLatest(ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_SIMCARD, getInfosSimCard)
	yield takeLatest(ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_BATTERY, getInfosBattery)
	yield takeLatest(ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_WS, getInfosWS)
}

export default sagas
